<div
  id="form-field-modal"
  class="modal"
  [ngClass]="{
    'd-block': (isModalVisible && !docked) || (isModalVisible && docked && fieldNavigatorSidebarVisible),
    'shadow-none docked': docked,
    'shadow rounded': !docked
  }"
  [ngStyle]="{ width: width + 'px' }">
  <div class="modal-content">
    <div *ngIf="pdfAnswersChanged">
      <p>This document was modified outside of the TXdocs Editor.</p>
    </div>
    <main
      #scrollDetector
      class="h-100"
      [ngClass]="{ 'no-content': !showHelpText && !obj }"
      [hidden]="pdfAnswersChanged">
      <ng-container *ngIf="!isActiveFieldSelected">
        <header>
          <div class="mt-2">
            <p>Please select a field for more information.</p>
          </div>
        </header>
      </ng-container>
      <ng-container *ngIf="isCalculatedField && isActiveFieldSelected">
        <header>
          <div class="mt-2">
            <p>{{ tokenDescription }}</p>
            <p>
              This field is automatically calculated by the values entered in the TXdocs assembly process. Proceed with
              caution when manually overwriting this value.
            </p>
          </div>
        </header>
      </ng-container>
      <ng-container *ngIf="!isCalculatedField && isActiveFieldSelected">
        <header>
          <span id="form-field-name" class="fw-lighter">{{ formField }}</span>
          <div class="d-flex align-items-center justify-content-start gap-3 mb-2">
            <button
              type="button"
              class="btn btn-titlebar btn-set-as-default text-uppercase me-auto"
              (click)="setDefault()"
              title="Set as default answer for this question">
              Set Default
            </button>
            <button
            type="button"
            class="btn btn-titlebar btn-set-as-default text-uppercase me-auto"
            (click)="openQuickTextDialog()"
            title="Choose and insert a QuickText">
            Quicktext
          </button>
            <button type="button" class="btn btn-titlebar bi-pin-angle" (click)="toggleDock()" title="Pin"></button>
            <!-- <button type="button" class="btn btn-titlebar" (click)="closeModal()" title="Close">
              <i class="bi bi-x-lg"></i>
            </button> -->
          </div>
        </header>

        <ng-container *ngIf="obj != null">
          <!-- text -->
          <ng-container *ngIf="(obj.columns == 0 || obj.rows == 0) && obj.inputType !== 'date'">
            <div class="form-floating">
              <input
                id="formFieldValue"
                type="text"
                class="form-control"
                [placeholder]="helpDescription"
                [(ngModel)]="value"
                (change)="updateFormFieldValue()"
                (input)="lockFieldAnswerPool()"
                (focus)="onFocusFormField()"
                (blur)="onBlurFormField($event)"
                [ngbTypeahead]="obj.autoComplete !== null && obj.autoComplete !== '' ? search : noSearch"
                [ngKeyboardShortcuts]="shortcuts"
                [maxlength]="obj.maxChars"
                [maskito]="obj.maskitoMask" />
              <label for="formFieldValue">{{ helpDescription }}</label>
            </div>
          </ng-container>
          <!-- multi line text -->
          <ng-container *ngIf="obj.columns > 0 && obj.rows > 0 && obj.inputType !== 'date'">
            <div class="form-floating flex-grow-1 h-100" [ngClass]="{ scrolled: isScrolled }">
              <textarea
                id="formFieldValue"
                type="text"
                class="form-control h-100"
                [placeholder]="helpDescription"
                [(ngModel)]="value"
                (change)="updateFormFieldValue()"
                (input)="lockFieldAnswerPool()"
                (focus)="onFocusFormField()"
                (blur)="onBlurFormField($event)"
                [ngKeyboardShortcuts]="shortcuts"
                [maxlength]="obj.maxChars"
                (scroll)="onElementScroll($event)"></textarea>
              <label for="formFieldValue">{{ helpDescription }}</label>
            </div>
          </ng-container>
          <!-- date -->
          <ng-container *ngIf="obj.inputType === 'date'">
            <div class="form-floating">
              <input
                id="formFieldValue"
                type="text"
                class="form-control"
                [(ngModel)]="value"
                (change)="updateFormFieldDateValue()"
                (input)="lockFieldAnswerPool()"
                (focus)="onFocusFormField()"
                (blur)="onBlurFormField($event)"
                [ngKeyboardShortcuts]="shortcuts"
                [maskito]="obj.maskitoMask"
                [placeholder]="obj.mask" />
              <label for="formFieldValue">{{ helpDescription }}</label>
            </div>
          </ng-container>
          
        </ng-container>

        <div
          id="form-field-help-wrapper"
          class="position-relative mb-2 truncated mt-2 h-100"
          [ngClass]="{ expanded: !isTruncated }"
          *ngIf="showHelpText">
          <div #helpTextContainer class="html-input-help-text" [innerHTML]="helpText"></div>
          <a
            href="#"
            class="more-link text-decoration-none link-secondary"
            (click)="toggleTruncated()"
            *ngIf="showMoreButton"
            tabindex="-1">
            <i class="bi bi-arrow-down-circle" *ngIf="isTruncated"></i>
            <i class="bi bi-arrow-up-circle" *ngIf="!isTruncated"></i>
          </a>
        </div>
      </ng-container>
      <footer *ngIf="!pdfAnswersChanged" class="d-flex justify-content-between flex-column">
        <div class="d-flex justify-content-between">
          <button
            type="button"
            class="btn btn-primary btn-sm d-flex align-items-center gap-2"
            (click)="updateAndNavigate(-1)"
            title="Navigate to the previous question"
            tabindex="-1">
            <i class="bi bi-arrow-left"></i>
            Previous
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm d-flex align-items-center gap-2"
            (click)="updateAndNavigate(1)"
            title="Navigate to the next question"
            tabindex="-1">
            Next
            <i class="bi bi-arrow-right"></i>
          </button>
        </div>
      </footer>
    </main>
  </div>
</div>
